import { Box, Button, Group, Text } from '@mantine/core';
import { modals } from '@mantine/modals';
import type { Node, NodeProps } from '@xyflow/react';
import { CircleQuestionMark, Plus } from 'lucide-react';
import { useShallow } from 'zustand/react/shallow';
import config from '@/app.config';
import styles from '@/components/column-heading/column-heading.module.css';
import useFlowStore from '@/store/flow';
import type { TFlowHeading } from '@/types/common.ts';

type ColumnHeadingNode = Node<TFlowHeading, 'columnHeading'>;

const ColumnHeading = ({ data }: NodeProps<ColumnHeadingNode>) => {
	const { cardSize, openFlowDrawer, configs } = useFlowStore(
		useShallow((state) => ({
			cardSize: state.cardSize,
			openFlowDrawer: state.openFlowDrawer,
			configs: state.canvas.configs
		}))
	);

	const handleClick = () => {
		openFlowDrawer(undefined, data.source.idn);
	};

	const handleOpenDescriptionModal = () => {
		modals.open({
			title: configs[data.source.idn].title,
			children: (
				<Box className={styles.descriptionBody}>
					<Text>{configs[data.source.idn]?.description}</Text>
				</Box>
			),
			size: 'xl'
		});
	};

	return (
		<Group
			className={styles.heading}
			justify="space-between"
			pl={16}
			style={{ '--type-color': data.source.color }}
			w={
				cardSize === 'extended'
					? config.view.extended.columns.width
					: config.view.compact.columns.width
			}
		>
			<Box className={styles.titleWrapper}>
				<span className={styles.square} />
				<Text
					fw={600}
					fz={13}
				>
					{data.source.title}
				</Text>

				<Button
					onClick={handleOpenDescriptionModal}
					p={0}
					variant="transparent"
				>
					<CircleQuestionMark opacity={0.5} />
				</Button>
			</Box>

			<Button
				className={styles.plusCta}
				onClick={handleClick}
			>
				<Plus color="black" />
			</Button>
		</Group>
	);
};

export default ColumnHeading;
